module.exports = __webpack_public_path__ + "static/media/Import_Light.65d97893.svg";